import { render } from "./nextcloud_body_main.vue?vue&type=template&id=beb75f68"
import script from "./nextcloud_body_main.vue?vue&type=script&lang=js"
export * from "./nextcloud_body_main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__